import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Form, PasswordInput, TextInput, InlineNotification } from '@carbon/react';
import SocialButtons from 'src/components/Auth/SocialButtons';
import { useAuthActions } from 'src/hooks/useAuthActions';

const SignUp = () => {
  const { t } = useTranslation('authentication');
  const navigate = useNavigate();
  const { signUp, signInSocial, isPending, error } = useAuthActions();
  const [form, setForm] = useState({ name: '', email: '', password: '' });

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    const result = await signUp(form.email, form.password, form.name);
    if (result) {
      navigate(`/verify-email?email=${encodeURIComponent(form.email)}`, { replace: true });
    }
  }

  return (
    <Form onSubmit={onSubmit} className="cds--auth__form">
      <h1>{t('signUp.title')}</h1>
      <p>{t('signUp.subtitle')}</p>
      {error && <InlineNotification kind="error" title={error.message} lowContrast hideCloseButton />}
      <TextInput
        id="name"
        labelText={t('signUp.name')}
        value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
        required
      />
      <TextInput
        id="email"
        type="email"
        labelText={t('signUp.email')}
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
        required
      />
      <PasswordInput
        id="password"
        labelText={t('signUp.password')}
        helperText={t('signUp.passwordHint')}
        value={form.password}
        onChange={(e) => setForm({ ...form, password: e.target.value })}
        required
      />
      <Button type="submit" disabled={isPending}>
        {t('signUp.submit')}
      </Button>
      <SocialButtons onSelect={signInSocial} />
      <Link to="/sign-in">{t('signUp.haveAccount')}</Link>
    </Form>
  );
};

export default SignUp;
